import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Home from './Home';
import ErrorPage from "./ErrorPage";
import Test from '../../Test/Test';
import OpenLayers from '../../Test/OpenLayers';

function HomePage(props){
    return (
        <div>
            <header className='landingpage-header'>
                <div className='title-container'>
                    <h1> AQcast2.0 </h1>
                </div>
            </header>
            <main className='main'>
                <div style={{borderTop: '2px solid black'}}></div>

                <Routes>
                    <Route path='/' element={
                        <Home
                            availablemodels={props.availablemodels}
                            modelmenulist={props.modelmenulist}
                            aermodAllowances={props.aermodAllowances}
                            memdate={props.memdate}
                            aermodTotalAllowances={props.aermodTotalAllowances}
                            scichemAllowances={props.scichemAllowances}
                            scichemTotalAllowances={props.scichemTotalAllowances}
                            wrfAllowances={props.wrfAllowances}
                            wrfTotalAllowances={props.wrfTotalAllowances}
                        />
                    }/>     
                    <Route path='/test' element={<Test/>}/>
                    <Route path='/openlayers' element={<OpenLayers/>}/>
                    <Route path='*' element={<ErrorPage/>}/>
                </Routes>
            </main>
        </div>
    );
}

export default HomePage
